import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorPageRoutingModule } from './error-page-routing.module';
import { ErrorPageComponent } from './error-page.component';
import {
  SharedComponentsUiModule,
  FormBuilderModule,
} from '@domgen/dgx-components';
import { ClaimSharedModule } from '../_shared/claim-shared.module';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';

@NgModule({
  declarations: [ErrorPageComponent],
  exports: [ErrorPageComponent],
  imports: [
    CommonModule,
    ErrorPageRoutingModule,
    SharedComponentsUiModule,
    ClaimSharedModule,
    FormBuilderModule,
    DgxComponentsIconModule,
  ],
})
export class ErrorPageModule {}
